// extracted by mini-css-extract-plugin
export var container = "_f4-0";
export var content = "_f4-3";
export var customerTitle = "_f4-4";
export var empty = "_f4-5";
export var gray = "_f4-6";
export var header = "_f4-7";
export var info = "_f4-8";
export var loading = "_f4-2";
export var loadingCard = "_f4-9";
export var oneLine = "_f4-a";
export var personName = "_f4-e";
export var pillContainer = "_f4-b";
export var selected = "_f4-1";
export var text = "_f4-c";
export var twoLines = "_f4-d";
export var unread = "_f4-f";
export var unreadIndicator = "_f4-g";